module.exports = __webpack_public_path__ + "static/media/modal.5b15117f.png";